import { render } from "./EstagioColumn.vue?vue&type=template&id=45fd5240&scoped=true"
import script from "./EstagioColumn.vue?vue&type=script&lang=js"
export * from "./EstagioColumn.vue?vue&type=script&lang=js"

import "./EstagioColumn.vue?vue&type=style&index=0&id=45fd5240&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45fd5240"]])

export default __exports__